// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".exit-chart .highcharts-lollipop-low{fill:#ffb743!important}.exit-chart .highcharts-lollipop-high{fill:#3e7ad3!important}", ""]);
// Exports
module.exports = exports;
